module.exports = __webpack_public_path__ + "img/logo3.707a945a.jpg";